export default __webpack_public_path__ + "static/media/qualitative-research.6cfbb971.png";